import { ArrowDownTrayIcon, CheckIcon } from "@heroicons/react/20/solid";
import Imarika1 from "../../assets/Imarika1.png"

import {
  Square3Stack3DIcon,
  UserCircleIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/solid";
import React from "react";

export default function ImarikaInvPlanTab2() {
  return (
    <div className="text-ternary-dark dark:text-ternary-light  ">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
          
            <p className="mt-6 text-base leading-7 ">

            Kenyan citizen with a valid national ID or passport and KRA pin number.
                        </p>
            <p className="mt-6 text-base leading-7 ">
            Resident with a valid resident’s certificate, KRA Pin number & work permit.            </p>
            <p className="mt-6 text-base leading-7 ">
            Free Life Insurance: Imarika provides you with Free Life Insurance cover of Kes 50,000
            </p>
            <p className="mt-6 text-base leading-7 ">
            Age between 18 and 75 years on signup.</p>
            <p className="mt-6 text-base leading-7 ">
            Have an email address.</p>
            
            <div className="mt-10 flex items-center gap-x-4">
     
            </div>
          </div>
       
        </div>
      </div>
    </div>
  );
}
